module.exports = __webpack_public_path__ + "static/img/icon-hardware.ce44189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-hardware.png
// module id = 3m51
// module chunks = 1